module.exports = __webpack_public_path__ + "static/media/up.7c45fca4.svg";